/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useState, useEffect } from 'react';
import { withRouter, useHistory } from "react-router-dom";
import { Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, Button, Carousel } from 'react-bootstrap';
import Card from 'Admin/components/Card/Card.jsx';
import * as API from '../../../../api/emr'

const AddEditDrugCategory = (props) => {
    let history = useHistory();

    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState(null);
    const [isSpecialCharacter, setIsSpecialChar] = useState(false)
    const [mode, setMode] = useState("add");
    const [drugCategoryId, setDrugCategoryId] = useState("")
    const [sequenceAlreadyExist, setSequenceAlreadyExist] = useState(false)
    const [sequenceAlreadyExistMsg, setSequenceAlreadyExistMsg] = useState(false)

    const inputHandler = (e) => {
        if (e.target.name === "sequence" && sequenceAlreadyExist) {
            setSequenceAlreadyExist(false)
            setSequenceAlreadyExistMsg("")
        }
        let saveFormData = formData;
        let str = e.target.value.replace(/\s+/g, " ");
        saveFormData[e.target.name] = str.trimStart()
        setFormData({ ...formData, ...saveFormData });
        validate();
    }

    const validate = () => {
        let post = formData;
        let errArr = errors;
        let errflag = true;
        if (post.sequence && post.sequence != '') {
            errArr.sequence = '';
        } else { errArr.sequence = 'error'; errflag = false; }

        if (post.drugCategoryName && post.drugCategoryName != '') {
            errArr.drugCategoryName = '';
        } else { errArr.drugCategoryName = 'error'; errflag = false; }

        setErrors({ ...errArr });
        return errflag;
    }

    const submitHandler = async (event) => {
        event.preventDefault();

        if (validate()) {
            setIsLoading(true);
            let sentData = new FormData();
            sentData.append('drugCategoryName', formData.drugCategoryName)
            sentData.append('sequence', formData.sequence)
            let resp = ""
            if (mode === "add") {
                resp = await API.addDrugCategory(sentData);
                if (resp.data.statusCode == 200 && resp.data.status === "Success") {
                    if (resp.data.flag && resp.data.flag === "existing") {
                        setSequenceAlreadyExist(true)
                        setSequenceAlreadyExistMsg(resp.data.msg)
                    }
                    else history.push({ pathname: "/admin/drugCategory-list", from: "add" })

                }
            } else {
                sentData.append('id', drugCategoryId)
                resp = await API.updateDrugCategory(sentData);
                setIsLoading(false);
                if (resp.data.statusCode == 200 && resp.data.status === "Success") {

                    if (resp.data.flag && resp.data.flag === "existing") {
                        setSequenceAlreadyExist(true)
                        setSequenceAlreadyExistMsg(resp.data.msg)
                    } else history.push({ pathname: "/admin/drugCategory-list", from: "edit" })
                }
            }
            setIsLoading(false);
        }
    }


    useEffect(() => {
        let row = props.location.state?.row;
        let saveFormData = formData;
        saveFormData["sequence"] = "";
        saveFormData["drugCategoryName"] = "";

        if (row !== undefined && row) {
            setMode("edit");
            setDrugCategoryId(row._id);
            saveFormData["sequence"] = row.sequence;
            saveFormData["drugCategoryName"] = row.name;

            setFormData({ ...formData, ...saveFormData });
        }

    }, [])
    return (
        <div className="main-content">

            <Grid fluid>
                <Row>
                    <Col md={12}>
                        <Card
                            title={<legend className="line-removes">
                                <Button className="go-back-btn-1" bsStyle="info" onClick={(e) => { history.goBack() }}>Back</Button>
                            </legend>}
                            content={
                                <Form horizontal className="add-supportsystem_form">

                                    <fieldset>
                                        <FormGroup>
                                            <Col sm={12}>
                                                <Row>
                                                    <Col md={6}>
                                                        <ControlLabel>Drug Category<span className="star">*</span></ControlLabel>
                                                        <FormControl
                                                            type="text"
                                                            name="drugCategoryName"
                                                            id="drugCategoryName"
                                                            placeholder="Category"
                                                            onChange={e => { inputHandler(e); }}
                                                            autocomplete="off"
                                                            value={formData.drugCategoryName ? formData.drugCategoryName : ''}
                                                            className={'insulin-input ' + (errors.drugCategoryName ? errors.drugCategoryName : '')}
                                                        />
                                                        {isSpecialCharacter &&
                                                            <span className="star">Special Characters Are Not Allowed</span>
                                                        }

                                                    </Col>
                                                </Row>
                                            </Col>
                                        </FormGroup>
                                    </fieldset>
                                    <fieldset>
                                        <FormGroup>
                                            <Col sm={12}>
                                                <Row>
                                                    <Col md={6}>
                                                        <ControlLabel>Sequence<span className="star">*</span></ControlLabel>
                                                        <FormControl
                                                            type="number"
                                                            name="sequence"
                                                            id="sequence"
                                                            placeholder="Sequence"
                                                            onChange={e => { inputHandler(e); }}
                                                            autocomplete="off"
                                                            value={formData.sequence ? formData.sequence : ''}
                                                            className={'insulin-input ' + (errors.sequence ? errors.sequence : '')}
                                                        />
                                                        {sequenceAlreadyExist &&
                                                            <span className="star">{sequenceAlreadyExistMsg}</span>
                                                        }

                                                    </Col>
                                                </Row>
                                            </Col>
                                        </FormGroup>
                                    </fieldset>
                                    <fieldset>
                                        <FormGroup>
                                            <ControlLabel className="col-sm-2">
                                            </ControlLabel>
                                            <Col sm={12} className="btn_wrap">
                                                <Row>
                                                    <Col md={12}>
                                                        <button
                                                            type="button"
                                                            disabled={isLoading}

                                                            className="btn-fill btn-wd btn btn-primary" onClick={e => { submitHandler(e) }}>
                                                            {isLoading && <span class="fa fa-spinner fa-spin spinner-btn"></span>}
                                                            Submit
                                                        </button>&nbsp;

                                                    </Col>
                                                </Row>
                                            </Col>
                                        </FormGroup>
                                    </fieldset>
                                </Form>
                            }
                        />
                    </Col>
                </Row>
            </Grid>

        </div>
    )
}

export default AddEditDrugCategory